const phoneSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="22.863px" height="22.864px" viewBox="0 0 22.863 22.864" enable-background="new 0 0 22.863 22.864" xml:space="preserve">
<g id="Layer_1">
	<g>
		<path fill="#FFFFFF" stroke="#FFFFFF" stroke-width="0.75" stroke-miterlimit="10" d="M22.473,18.575
			c-0.07-0.531-0.376-0.99-0.84-1.258l-5.456-3.141c-0.668-0.385-1.515-0.271-2.062,0.273l-1.074,1.074
			c-0.286,0.285-0.739,0.311-1.053,0.059c-0.847-0.682-1.681-1.432-2.479-2.23c-0.798-0.797-1.547-1.631-2.23-2.479
			c-0.252-0.314-0.228-0.766,0.06-1.051l1.073-1.076C8.959,8.202,9.07,7.354,8.686,6.687L5.545,1.231
			C5.277,0.767,4.818,0.46,4.287,0.39S3.234,0.495,2.855,0.874L1.236,2.493C0.105,3.624,0.088,5.69,1.186,8.315
			c1.055,2.521,3.023,5.301,5.543,7.818c2.52,2.521,5.297,4.488,7.819,5.545c1.292,0.539,2.448,0.811,3.425,0.811
			c1.008,0,1.822-0.289,2.396-0.863l1.619-1.619C22.367,19.628,22.544,19.106,22.473,18.575L22.473,18.575z M15.818,14.798
			l5.457,3.141c0.27,0.156,0.447,0.422,0.488,0.73c0.033,0.258-0.033,0.514-0.186,0.719l-7.25-4.137l0.294-0.295
			C14.938,14.64,15.432,14.573,15.818,14.798L15.818,14.798z M4.193,1.099c0.309,0.041,0.575,0.219,0.73,0.49l3.141,5.455
			c0.225,0.389,0.159,0.881-0.158,1.197l-0.27,0.27L3.476,1.284c0.17-0.125,0.374-0.193,0.585-0.193
			C4.105,1.091,4.149,1.093,4.193,1.099L4.193,1.099z M19.862,21.12c-0.897,0.898-2.734,0.859-5.038-0.104
			c-2.439-1.02-5.135-2.934-7.59-5.389s-4.369-5.15-5.389-7.59C0.882,5.735,0.845,3.897,1.742,3.001l1.203-1.203l4.166,7.238
			L6.832,9.315c-0.545,0.545-0.594,1.408-0.111,2.008c0.699,0.867,1.467,1.721,2.282,2.537c0.815,0.814,1.669,1.582,2.536,2.281
			c0.6,0.482,1.463,0.434,2.008-0.109l0.255-0.256l7.261,4.143L19.862,21.12L19.862,21.12z"/>
	</g>
</g>
<g id="LiveTXT" display="none">
</g>
<g id="GRids">
</g>
</svg>
`;

export default phoneSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/phoneSVG.js